// extracted by mini-css-extract-plugin
export default {"section":"WxbdXU7QjEY28BxmFWuu","loading":"jFHrFrxDWlM1bREXiUP8"};